import { TweenLite } from 'gsap';

const docReady = fn => {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

const handleScrollTo = el => {
  const header = document.querySelector('.site-header');
  const actionBar = document.querySelector('.action-bar');

  let additionalOffset = 20;
  if (actionBar !== null && actionBar.classList.contains('fixed')) {
    additionalOffset = actionBar.offsetHeight + 20;
  }

  TweenLite.to(window, 0.6, {
    scrollTo: {
      y: el.offsetTop,
      offsetY: header.offsetHeight + additionalOffset,
    },
  });
};

const handleItemClick = e => {
  e.preventDefault();

  const { target } = e;
  const element = document.querySelector(`[id="${target.hash.substring(1)}"]`);

  if (element !== null) {
    handleScrollTo(element);
  }
};

docReady(() => {
  if (window.location.hash) {
    const { hash } = window.location;
    if (hash) {
      const { body } = document;
      let element = null;
      const investmentsVersions = ['adviser', 'investor'];
      if (investmentsVersions.some(className => body.classList.contains(className))) {
        const elements = document.querySelectorAll(`[id="${hash.substring(1)}"]`);
        elements.forEach(el => {
          if (el.offsetTop !== 0) {
            element = el;
          }
        });
      } else {
        element = document.querySelector(`[id="${hash.substring(1)}"]`);
      }

      if (element !== null) {
        handleScrollTo(element);
      }
    }
  }
});

const buttons = document.querySelectorAll('.wp-block-button__link[href^="#"]');
if (buttons.length > 0) {
  buttons.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();

      handleItemClick(e);
    });
  });
}
